module.exports = __webpack_public_path__ + "img/10.3-gallery.af53be41.jpg";